import { bl_wf_md_transition_action_RowClass, bl_wf_md_transition_action_RowInterface } from "../../../dbschema";
import {BaseContainerModel} from "../../base-container.model";

export class WfMdTransitionActionContainerModel extends BaseContainerModel{
  bl_wf_md_transition_action: bl_wf_md_transition_action_RowInterface = new bl_wf_md_transition_action_RowClass();
}
